import React from 'react';

const results = [
  {
    label: 'Smoke Reduction',
    value: 'Up to 70%',
    detail: 'Cleaner stacks and visibly clearer exhaust from day one.',
  },
  {
    label: 'Boiler Efficiency',
    value: 'Higher output',
    detail: 'More stable steam generation at the same firing rate.',
  },
  {
    label: 'Overhaul Cycle',
    value: '1 → 3 months',
    detail: 'Reduced choking and carbon build‑up in burners and nozzles.',
  },
  {
    label: 'Fuel Recovery',
    value: 'Dead stock used',
    detail: 'Thick sludge and old fuel reclaimed instead of being written off.',
  },
  {
    label: 'Maintenance',
    value: 'Cleaner hardware',
    detail: 'Clean, carbon‑free guns and extended nozzle life.',
  },
  {
    label: 'Start‑up',
    value: 'Faster light‑up',
    detail: 'Reduced boiler light‑up time and smoother temperature ramp‑up.',
  },
];

const PerformanceResults = () => {
  return (
    <section className="section dark" id="performance-results">
      <h2 className="section-title">Performance at a Glance</h2>
      <p className="section-subtitle">
        Field‑measured improvements from industrial boilers and furnaces using MICRO 24.
      </p>
      <div className="performance-cards">
        {results.map((item, idx) => (
          <div key={idx} className="card">
            <div className="hero-kpi-label">{item.label}</div>
            <div className="hero-kpi-value" style={{ marginBottom: '0.4rem' }}>
              {item.value}
            </div>
            <p>{item.detail}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PerformanceResults;